/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const breakfast = useStore((state) => state.breakfast);
  const setBreakfast = useStore((state) => state.setBreakfast);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.breakfast.title')}</Title>
        <Text className='description' size='m' medium>
          {t('onboarding.breakfast.subtitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={breakfast}
          onChange={(value) => {
            setBreakfast(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'breakfast',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={true}>
            <span>🍞</span> {t('onboarding.breakfast.options.yes')}
          </Option>
          <Option value={false}>
            <span>🙅‍♀️</span> {t('onboarding.breakfast.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
